import { IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonHeader, IonImg, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { settings } from 'ionicons/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';

const PaymentComplete: React.FC = () => {

    const { authKey, authenticateMember, authorizedMember, getAuthorizedMember, loading, setLoading, level, getLevel, settings, getCountries, getStates, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();   

    useIonViewDidEnter(() => { 
        setLoading(false);
    }); 
        
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonRow class='ion-justify-content-center'>
                    <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                        <IonCard>
                            <IonCardContent>
                                <div className='ion-text-center'>
                                    {loading
                                        ? (<p>Processing...</p>)
                                        : (<>
                                                <h1 className='ion-text-center'>Your membership has been updated.</h1>
                                                                                                
                                                <p className='ion-text-center'><Link to="/account">Go to your Account</Link></p>
                                            </>
                                        )
                                    }
                                </div>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>    
            </IonContent>
        </IonPage>
    );
};

export default PaymentComplete;